import React from 'react';

import { GridEventListener, GridRowParams } from '@mui/x-data-grid';

import { reverse } from 'named-urls';

import Grid from 'components/Grid';

import { ColumnDefinition } from 'components/Grid/types';

import { useStore } from 'utils/hooks/store';

import routes from 'core/routes';

import EntityActionCell from 'components/Entities/EntityActionCell';
import { entityCreatedColumn } from 'components/Entities/EntityCreatedColumn';

import { EntityModules, ProtectorType } from 'core/constants';

import { ContactsTableProps } from './types';

export const basicContactsColumns = [
  {
    field: 'contacts__name',
    headerName: 'Name',
    protectorType: ProtectorType.ShortText,
  },
  {
    field: 'contacts__email',
    headerName: 'Email address',
    protectorType: ProtectorType.ShortText,
  },
  {
    field: 'contacts__phone',
    headerName: 'Phone number',
    protectorType: ProtectorType.ShortText,
  },
  entityCreatedColumn(EntityModules.Contacts),
] as unknown as ColumnDefinition[];

const ContactsTable: React.FunctionComponent<ContactsTableProps> = ({
  onError,
  onRefreshCallback,
}): React.ReactElement => {
  const { routing, contactDetails } = useStore();

  const onRowClick: GridEventListener<'rowClick'> = (item: GridRowParams): void => {
    routing.push(reverse(routes.dashboard.contacts.details, { entityId: item.id }));
  };

  return (
    <Grid
      basicColumns={
        [
          ...basicContactsColumns,
          {
            field: 'actions',
            type: 'actions',
            headerName: '',
            maxWidth: 50,
            ariaLabel: 'actions_cell',
            renderCell: ({ row, colDef }: { row: { uuid: string }; colDef: ColumnDefinition }) => (
              <EntityActionCell rowData={row} actions={colDef.actions} store={contactDetails} />
            ),
            filterOperators: null,
            sortable: false,
          },
        ] as unknown as ColumnDefinition[]
      }
      entity="contacts"
      onError={onError}
      dataURL="/api/entities/contacts/"
      fieldsURL="/api/entities/contacts/fields/"
      customNoRowsText="No contacts have been created yet"
      onRowClick={onRowClick}
      onRefreshCallback={onRefreshCallback}
      disableSelectAllColumns
      onlyBasicExport={false}
    />
  );
};

export default ContactsTable;
